module.exports = __webpack_public_path__ + "assets/img/world-map-small.66838bd3.jpg";